import { dataLayerPush } from 'src/helpers/gtm';
import { select, takeEvery } from 'redux-saga/effects';
import { getSearchType } from '../selectors/view';
import { choseNeighboringDateAnalyticsAction } from './actions';
import { getHotelId } from '../hotel';

export function* searchDoneAnalytics(
  status: 'error' | 'success' | 'no_results',
) {
  try {
    const searchType = yield select(getSearchType);
    const hotelId = yield select(getHotelId);
    dataLayerPush({
      event: 'nearest_hotel_dates_found',
      custom_params: {
        hotel_id: hotelId,
        search_type: searchType,
        status,
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Ошибка в аналитике searchDoneAnalytic', error);
  }
}

export function* choseNeighboringDateAnalytics(
  action: ReturnType<typeof choseNeighboringDateAnalyticsAction>,
) {
  try {
    const searchType = yield select(getSearchType);
    const hotelId = yield select(getHotelId);
    dataLayerPush({
      event: 'nearest_hotel_dates',
      custom_params: {
        hotel_id: hotelId,
        search_type: searchType,
        nights_count: action.payload.nightsCount,
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Ошибка в аналитике choseNeighboringDateAnalytic', error);
  }
}

export default function* closestDatesAnalyticsWatcher() {
  yield takeEvery(
    choseNeighboringDateAnalyticsAction,
    choseNeighboringDateAnalytics,
  );
}
